/**
 * Which years a timeline chart's x-axis labels, from the width each year's
 * slot gets. On a phone, eleven four-digit labels ("2016" … "2026") are
 * wider than their slots and run together, so a narrow axis labels every
 * second (or third …) year instead. The count runs back from the LAST
 * year, so the in-progress "(to date)" year always keeps its label.
 *
 * Two-digit years ('16 … '26) were tried first and rejected: at phone size
 * the apostrophe reads as belonging to the previous label ("16’ 17’").
 */

// A four-digit year is ~2.4 font-sizes wide (a digit ≈ 0.6em), plus a gap.
const YEAR_LABEL_EM = 3;

/** Label every `step`th year: 1 when four-digit labels fit every slot. */
export function yearLabelStep(slotWidth: number, fontSize: number): number {
  if (!(slotWidth > 0)) return 1;
  return Math.max(1, Math.ceil((fontSize * YEAR_LABEL_EM) / slotWidth));
}

/** Whether the label at `index` of `count` shows, stepping back from the last. */
export function showsYearLabel(index: number, count: number, step: number): boolean {
  return (count - 1 - index) % step === 0;
}
